var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.648 12.1504C21.2075 11.7155 26.7924 11.7155 32.3518 12.1504L36.0863 12.4426C38.1665 12.6053 39.8682 14.1643 40.212 16.2223C41.0724 21.3714 41.0724 26.6277 40.212 31.7768C39.8682 33.8348 38.1665 35.3938 36.0863 35.5565L32.3518 35.8487C26.7924 36.2836 21.2075 36.2836 15.648 35.8487L11.9135 35.5565C9.83339 35.3938 8.13169 33.8348 7.78784 31.7768C6.92749 26.6277 6.92749 21.3714 7.78784 16.2223C8.13169 14.1643 9.83339 12.6053 11.9135 12.4426L15.648 12.1504ZM20.6665 28.1165V19.8827C20.6665 19.494 21.0905 19.254 21.4238 19.4539L28.2853 23.5708C28.609 23.765 28.609 24.2341 28.2853 24.4283L21.4238 28.5452C21.0905 28.7452 20.6665 28.5051 20.6665 28.1165Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b6c579dbc434f49e13d9699dc42a6d8f.svg";
export { ForwardRef as ReactComponent };